import type { Geometry } from "geojson";
import Immutable from "immutable";
import {
  BoundaryMapResponse,
  SchoolBoundaries,
} from "src/components/Boundary/schemas";

/**
 * Transforms the API response with geometry references into expanded boundaries.
 * This expands geometryRef back to full geometry objects for backward compatibility.
 */
export function expandBoundaryMapResponse(
  response: BoundaryMapResponse
): Immutable.Map<uuid, SchoolBoundaries> {
  const { geometries, boundaries } = response;

  const expandedBoundaries: Record<uuid, SchoolBoundaries> = {};

  for (const [key, schoolBoundariesRef] of Object.entries(boundaries)) {
    expandedBoundaries[key] = {
      boundaries: schoolBoundariesRef.boundaries.map((boundaryRef) => {
        const geometry = geometries[boundaryRef.geometryRef] as Geometry;
        return {
          geometry,
          geoEligibility: boundaryRef.geoEligibility,
          tags: boundaryRef.tags,
          name: boundaryRef.name,
          schoolId: boundaryRef.schoolId,
        };
      }),
    };
  }

  return Immutable.Map<uuid, SchoolBoundaries>(expandedBoundaries);
}
